
module dg.actions {

    class KpiBarController {

        public options: any;
        public queryManipulator: dg.actions.QueryManipulator;
        public KPIS: any[];

        public constructor(
            protected $scope: ng.IScope,

        ) {
        }

        $onInit = () => {
            
        }


        $onChanges = (changes) => {
            if (changes.queryManipulator && changes.queryManipulator.currentValue) {
                this.reloadData();
                this.queryManipulator.onResultChanged(this.reloadData);
            }
        }


        private reloadData = () => {
            this.KPIS = this.queryManipulator.result.items;

            //this.queryManipulator.getData().then((data: any) => {
            //    this.KPIS = data.items;
            //});
            //this.$scope.$apply();
        }
    }

    angular.module('dg.actions').component('kpiBar', {
        bindings: {
            queryManipulator: '<',
            options: '<'
        },
        controller: KpiBarController,
        templateUrl: '/digmo/src/actions/kpi/kpi-bar.html'
    });
}